export default __webpack_public_path__ + "static/media/pvc-free.0613bc92.svg";